import { useEffect, useRef } from 'react';

import { useAppCommons } from '~/effects';

export const useGlobalOffsetWellsSync = (offsetSettings, onChange, maxOffsetWellNumber) => {
  const appCommons = useAppCommons();
  const globalOffsetWells = appCommons?.globalOffsetWells;
  const globalOffsetWellsVersion = appCommons?.globalOffsetWellsVersion;
  const prevVersionRef = useRef();

  useEffect(() => {
    if (!globalOffsetWells || !Array.isArray(globalOffsetWells)) return;
    if (globalOffsetWellsVersion === undefined) return;

    if (prevVersionRef.current === undefined) {
      prevVersionRef.current = globalOffsetWellsVersion;
      return;
    }

    if (prevVersionRef.current === globalOffsetWellsVersion) return;
    prevVersionRef.current = globalOffsetWellsVersion;
    const globalOffsetWellsTrimmed = globalOffsetWells.slice(0, maxOffsetWellNumber);

    const currentIds = globalOffsetWellsTrimmed.map(w => w.id);
    const baseSettings = offsetSettings || {};

    onChange({ ...baseSettings, selectedWellIds: currentIds }, globalOffsetWellsTrimmed);
  }, [globalOffsetWellsVersion, globalOffsetWells, maxOffsetWellNumber, offsetSettings, onChange]);
};
